export default "__VITE_ASSET__BtW$bUqe__"